import ReactGA from "react-ga4";

export function analyticsEvent(category, action, label) {
  ReactGA.event({
    category,
    action,
    label
  });
}
